import Logo2 from '../../images/negativ-main-logo.webp';
import useDictionary from "../../hooks/useDictionary";

import { useParams } from "react-router-dom";

export default function S3Finish() {

    const params = useParams();
    const dictionary = useDictionary();

    return (
        <div className="thank-you">

            <img alt="Negativ Brand Logo" src={Logo2} />

            <div className="text">

                <h3>{dictionary.THANK_YOU}</h3>
                <p>{dictionary.THANKS_FOR_THE_REG}</p>
                <p>{dictionary.AFTER_REG_INFO}</p>

            </div>

            <div className="controls">
                <a className="univ-button" href={`/${params.lang}/negativ`}>{dictionary.GO_BACK_TO_HOME}</a>
            </div>

        </div>
    )

}